<template>
	<transition name="pop-fade">
		<div
		 class="mealConfirm pop-fade-container"
		 v-show="meal.id"
		>
			<div
			 class="maskContainer"
			 @click="hideConfirm"
			></div>
			<div class="confirmContainer">
				<img
				 src="@/assets/images/shop/close_gray.png"
				 alt
				 class="close"
				 @click="hideConfirm"
				>
<!--				<div class="title">{{meal.name}}</div>-->
				<div class="title">
          	<img class="titleImg"
             :src="meal.pic"
             alt
            >
          <div class="titleName">{{meal.name}}</div>
          <div class="titleProp">已选：
<!--            <span>{{checkedParter.list.map(p=>p.name).join('/')}}</span>-->
<!--            <span v-for="checkedProp in checkedParter.list" :key="checkedProp.id">{{checkedProp.name}}</span>-->
            <span>{{checkedParterProperty.list.map(p=>p.title).join('/') + " , "}}</span>
<!--            <span v-for="checkedProp in checkedParterProperty.list" :key="checkedProp.id">{{checkedProp.title}}</span>-->
<!--            <span v-for="checkedProp in checkedProperty.list" :key="checkedProp.id">{{checkedProp.title}}</span>-->
            <span>{{checkedProperty.list.map(p=>p.title).join(' , ')}}</span>
          </div>
        </div>
				<div class="content">
					<section v-if="parter.length>0">
						<template v-for="(itemOuter,indexOuter) in parter">
							<header v-if="itemOuter.length>0">搭配：</header>
							<template v-for="(itemInner,indexInner) in itemOuter">
								<div class="labelList clearfix">
									<label
									 v-for="(item,index) in itemInner"
									 :key="index"
									 :class="{'selected':item.checked == 1}"
									 @click.stop="checkParter(itemInner,index)"
									>{{item.name}}</label>
								</div>
								<section
								 v-for="(property,PindexOuter) in parter_propertys[indexInner]"
								 :key="PindexOuter"
								 v-if="parter_propertys[indexInner].length > 0"
								 class="inner"
								>
									<header>{{property.title}}：</header>
									<div class="labelList clearfix">
										<label
										 v-for="(child,indexInner) in property.childs"
										 :key="indexInner"
										 :class="{'selected':child.checked == 1}"
										 @click.stop="checkProperty(property,indexInner)"
										>{{child.title}}</label>
									</div>
								</section>
							</template>
						</template>
					</section>
					<section
					 v-for="(item,indexOuter) in property"
					 :key="indexOuter"
					>
						<header>{{item.title}}：</header>
						<div class="labelList clearfix">
							<label
							 v-for="(child,indexInner) in item.childs"
							 :key="indexInner"
							 :class="{'selected':child.checked == 1}"
							 @click.stop="checkProperty(item,indexInner)"
							>{{child.title}}</label>
							<!-- <label class="selected">3分糖-0元</label>
							<label>5分糖-5元</label>
							<label>7分糖-0元</label>-->
						</div>
					</section>
				</div>
				<div class="bottom">
          <div class="price" v-if="false">￥{{showPrice}}</div>
					<div
					 class="btn"
					 @click.stop="submit"
					>￥{{showPrice}} ,  选好了</div>
				</div>
				<div class="bottomText"><!-- 如无需搭配，请直接点击【选好了】 --></div>
			</div>
		</div>
	</transition>
</template>
<script>
import $localStorage from "@/utils/localStorage";
import Decimal from 'decimal.js'

export default {
	props: {
		meal: {
			type: Object,
			required: true
		},
		timeOptions: {
			type: Object,
			required: true
		},
		shopOptions: {
			type: Object,
			required: true
		}
	},
	computed: {
		// 属性
		property() {
			return this.meal.property || [];
		},
		// 搭配
		parter() {
			return this.meal.parter || [];
		},
		// 搭配中的属性
		parter_propertys() {
			let arr = [];
			this.parter.forEach(v => {
				v.forEach(v2 => {
					v2.forEach(v3 => {
						if (v3.checked == 1) {
							arr.push(v3.parter_property);
						}
					});
				});
			});
			return arr;
		},
		// 选中的属性
		checkedProperty() {
			let list = [],
				ids = [],
				price = 0;
			this.property.forEach(v => {
				v.childs.forEach(v2 => {
					if (v2.checked == 1 && v2.parter_meal_id != 0) {
						list.push(v2);
						ids.push(v2.id);
						price += parseFloat(v2.price);
					}
				});
			});
			return { list, ids: ids.join(","), price };
		},
		// 选中的搭配
		checkedParter() {
			let list = [],
				ids = [],
				price = 0;
			this.parter.forEach(v => {
				v.forEach(v2 => {
					v2.forEach(v3 => {
						if (v3.checked == 1 && v3.parter_meal_id != 0) {
							list.push(v3);
							ids.push(v3.parter_meal_id);
							price += parseFloat(v3.price);
						}
					});
				});
			});
			return { list, ids: ids.join(","), price };
		},
		// 选中的搭配中选中的属性
		checkedParterProperty() {
			let list = [],
				ids = [],
				price = 0;
			this.checkedParter.list.forEach(v => {
				v.parter_property.forEach(v2 => {
					v2.childs.forEach(v3 => {
						if (v3.checked == 1 && v3.parter_meal_id != 0) {
							list.push(v3);
							ids.push(v3.id);
							price += parseFloat(v3.price);
						}
					});
				});
			});
			return { list, ids: ids.join(","), price };
		},
		// 搭配价格
		parterPropertyPrice() {
       let sum = new Decimal('0');
      sum = sum.plus(new Decimal(this.checkedProperty.price))
      sum = sum.plus(new Decimal(this.checkedParter.price))
      sum = sum.plus(new Decimal(this.checkedParterProperty.price))

      return sum.toString();
			// let price = 0;
			// price += parseFloat(this.checkedProperty.price);
			// price += parseFloat(this.checkedParter.price);
			// price += parseFloat(this.checkedParterProperty.price);
			// return price;

		},
    showPrice(){
      let bool = this.meal.rebate_price&&this.meal.rebate_price!='0.00'&&this.meal.rebate_price!=this.meal.price
      let price = new Decimal("0");
      if(bool){
        price = new Decimal(this.meal.rebate_price);
      } else {
        if(this.meal.price){
          price = new Decimal(this.meal.price);
        }
        price = price.plus(new Decimal(this.parterPropertyPrice));
      }
     // return price.toString() + this.meal.unit;
     return price.toString() ;
    },
	},
	data() {
		return {
    };
	},
	methods: {
		checkParter(itemParent, index) {
      console.info('this checkedParter',this.checkedParter)
      console.info('this checkedParterProperty',this.checkedParterProperty)
			itemParent.map((v, i) => {
				if (v.checked == undefined) {
					this.$set(v, "checked", 0);
				}
				if (i == index) {
					v.checked = 1;
				} else {
					v.checked = 0;
				}
				return v;
			});
		},
		checkProperty(itemParent, index) {
			itemParent.childs.map((v, i) => {
				if (v.checked == undefined) {
					this.$set(v, "checked", 0);
				}
				if (i == index) {
					v.checked = 1;
				} else {
					v.checked = 0;
				}
				return v;
			});
		},
		submit() {
      let parter = [];
      this.checkedParter.list
          .filter(p => p.checked == 1)
          .forEach(p => {

        let childPropertyList = p.parter_property;
        let propertyIds = [];
        childPropertyList.forEach(c => {
          let cid = c.childs.filter(child => child.checked == 1)
              .map(child => child.id);
          propertyIds.push(cid)
        });

        let parterPropertyIds = propertyIds.join(',')
        let parterObj = {
                      "parter_id": p.parter_meal_id,
                      "parter_name": p.name,
                      "parter_property_ids": parterPropertyIds,
                      "parter_type_id": p.perter_type_id
                  };
          parter.push(parterObj);
        })

			this.$emit("submit", "addMeal", {
				checkedProperty: this.checkedProperty.list,
				checkedPropertyIds: this.checkedProperty.ids,
				checkedParter: this.checkedParter.list,
				checkedParterIds: this.checkedParter.ids,
				checkedParterProperty: this.checkedParterProperty.list,
				checkedParterPropertyIds: this.checkedParterProperty.ids,
				meal: this.meal,
				amount: 1,
				meal_id: this.meal.id,
				price: parseFloat(this.meal.price),
				rebate_price: parseFloat(this.meal.rebate_price),
				hasDiscount: !!(
					this.meal.rebate_price &&
					this.meal.rebate_price != "0.00" &&
					this.meal.rebate_price != this.meal.price
				),
				discount:
					parseFloat(this.meal.price) -
					parseFloat(this.meal.rebate_price),
				parterPropertyPrice: this.parterPropertyPrice,
        parter:parter
			});
		},
		hideConfirm() {
			this.$emit("submit", "cancel");
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
@import "~@/scss/transition.scss";
.mealConfirm {
	@include square(100%);
	@include pos-f(0, 0, 0, 0);
	z-index: 1000;
	.maskContainer {
		@include mask-container;
	}
	.confirmContainer {
		//width: px2rem(580);
		width: 95%;
    height: 95%;
    top: 2%;
		border-radius: px2rem(10);
		background-color: white;
		@include transform-center;
		.close {
			@include pos-a(20, 20);
			@include square(40);
		}
		.title {
			font-size: px2rem(32);
			color: #545b5b;
			margin: px2rem(40) 0 px2rem(20);
			text-align: center;
      padding-bottom: 5%;

      .titleImg{
        float: left;
        margin-left: 5%;
        margin-right: 2%;
        border-radius: 15%;
        height: px2rem(100);
        width: px2rem(100);
      }
      .titleName{
        //float: left;
        //width: 100%;
        text-align: left;
        padding-left: 20px;
      }
      .titleProp{
        //float: left;
        margin-top: 10px;
        color: gray;
        //font-size: 18px;
        font-size: px2rem(22);
        text-align: left;

        span {
          margin-right: px2rem(5);
        }
      }
		}
		.content {
			width: 100%;
      height: 70%;
			max-height: 85%;
			//max-height: px2rem(2000);
			//max-height:  calc(20% - (px2rem(200)));
			@extend %overflow-scroll;
		}
		section {
			padding: px2rem(20);
			header {
				width: 100%;
				font-size: px2rem(28);
				color: #545b5b;
			}
			.labelList {
				width: 100%;
				label {
					float: left;
					display: block;
					min-width: px2rem(150);
					height: px2rem(60);
					background-color: #f7f7f7;
					line-height: px2rem(60);
					text-align: center;
					padding: 0 px2rem(20);
					margin-top: px2rem(20);
					margin-right: px2rem(20);
					border-radius: px2rem(10);
					border: px2rem(1) solid #d2d6d6;
					font-size: px2rem(26);
					color: #7b7f81;
					&.selected {
						border-color: #73c6c8;
						background-color: #F3FBFB;
						color: #73c6c8;
					}
				}
			}
			&.inner {
				margin-top: px2rem(20);
				border: px2rem(1) solid #d2d6d6;
				border-radius: px2rem(10);
				@include triangle(#d2d6d6, #fff, up);
			}
		}
		.bottom {
			//margin-top: px2rem(20);
      position: fixed;
      bottom: 0;
      height: 5%;
      //height: px2rem(60);
			@include square(100%, 112);
			padding: px2rem(30) px2rem(30) px2rem(20);
			border-top: px2rem(1) solid #e4e4e4;
			@include dis-flex(center, space-between);
			.price {
				font: {
					size: px2rem(40);
					weight: bold;
				}
				color: #e32351;
			}
			.btn {
				font-size: px2rem(30);
				color: white;
				border-radius: px2rem(27);
				line-height: px2rem(60);
				@include square(200, 60);
				text-align: center;
				background-color: #72c6c8;
        width: 100%;
			}
		}
		.bottomText {
			width: 100%;
			padding: 0 px2rem(30) px2rem(30);
			color: #7b7f81;
			font-size: px2rem(26);
		}
	}
}
</style>
